/*
Copyright 2026 New Vector Ltd.

SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-Element-Commercial
Please see LICENSE in the repository root for full details.
*/

import { type FC, type ReactNode, useEffect, useState } from "react";

import { setSettingsRoom } from "./settings";

interface Props {
  /** Идентификатор Matrix-комнаты, к которой привязываем настройки. */
  roomId: string;
  children: ReactNode;
}

/**
 * Включает настройки этой комнаты на всё время, пока звонок открыт, и
 * возвращает общие настройки при выходе.
 *
 * Детей показываем только после привязки, и это не перестраховка: эффекты
 * дочерних компонентов выполняются раньше родительских, поэтому лобби успело бы
 * открыть камеру и микрофон по общим настройкам, а нужные подставились бы уже
 * следом. Человек видел бы, как устройство переключается само собой сразу после
 * входа.
 */
export const RoomSettingsScope: FC<Props> = ({ roomId, children }) => {
  const [boundRoomId, setBoundRoomId] = useState<string | undefined>(undefined);

  useEffect(() => {
    setSettingsRoom(roomId);
    setBoundRoomId(roomId);
    return (): void => setSettingsRoom(undefined);
  }, [roomId]);

  return boundRoomId === roomId ? <>{children}</> : null;
};
